import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEY, queryConsolidationConfiguration } from 'src/queries/queryConsolidationConfiguration';

type ConsolidationConfiguration = Models.IngestConfigApi.ConsolidationConfiguration;

export const useQueryConsolidationConfiguration = (
    accessToken: string | undefined | false,
    productKey: string,
    options?: UseQueryOptions<
    ConsolidationConfiguration | null,
    Error,
    ConsolidationConfiguration | null,
    App.ConsolidationConfiguration.QueryKey
    >,
): UseQueryResult<ConsolidationConfiguration | null, Error> => useQuery<
ConsolidationConfiguration | null,
Error,
ConsolidationConfiguration | null,
App.ConsolidationConfiguration.QueryKey
>(
    [QUERY_KEY, accessToken, productKey],
    queryConsolidationConfiguration,
    options,
);
